import { Component, Input } from '@angular/core';

@Component({
  selector: 'lm-drawer-side-collapsed',
  template: '<ng-content *ngIf="collapsed"></ng-content>',
  styleUrls: ['./lm-drawer-side-collapsed.component.scss']
})
export class LMDrawerSideCollapsedComponent {
  @Input() collapsed = false;
}
